import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'digitFormat'
})
export class DigitFormatPipe implements PipeTransform {
  transform(value: any): number {
    return parseFloat(value.toFixed(2));
  }
}